import styled from 'styled-components';
import { ModalHeader } from 'reactstrap';
import { Button } from '@shoflo/polymer/components/Button/Button';
export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  width: 100%;
  left: 0px;
  top: 104px;
  background: #f9f9fb;
  flex-wrap: wrap;
  order: 3;
  margin: 0px 10px;
  max-height: 70vh;
  overflow-y: hidden;

  &:hover {
    overflow-y: scroll;

    > section {
      width: 100%;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none !important;
      background-color: transparent !important;
    }

    &::-webkit-scrollbar {
      width: 6px !important;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #acacac;
    }
  }
`;

export const StyledCloseButton = styled(Button)`
  box-sizing: border-box;
  margin-left: 16px;

  &:hover,
  &:active {
    color: #000000 !important;
    background-color: #ffffff !important;
  }
  &:focus {
    background-color: #ffffff;
    box-shadow: 0 0 0 0.0625rem #0095ff;
  }
`;

export const StyledJustifyRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledModalHeader = styled(ModalHeader)`
  h5 {
    font-weight: 600;
    font-size: 22px;
    line-height: 32px;
    color: #33373d;
  }

  p {
    font-weight: lighter;
    font-size: 16px;
    margin-bottom: 0px;
    color: #6e7582;
  }

  padding-bottom: 0px;
  border-bottom: none;
`;
